/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const getChainNameFromId = (chainId: any) => {
    switch (chainId) {
        case 1:
            return "Ethereum Mainnet";
        case 3:
            return "Ethereum Ropsten";
        case 4:
            return "Ethereum Rinkeby";
        case 137:
            return "Polygon Mainnet";
        case 80001:
            return "Mumbai Testnet";
        default:
            return chainId;
    }
};

export const providerTypeToChain = (providerType: string) => {
    if (providerType) {
      switch (providerType.toLowerCase().trim()) {
        case 'mainnet-ethr-did':
          return 'mainnet';
        case 'rinkeby-ethr-did':
          return 'rinkeby';
        case 'ropsten-ethr-did':
          return 'ropsten';
        case 'central-ethr-did':
          return 'central';
        case 'david19-ethr-did':
          return 'david19';
        case 'academy-ethr-did':
          return 'academy';
        case 'mainnet-polygon-did':
          return 'mainnet';
        case 'testnet-polygon-did':
          return 'testnet';
        default:
          return null;
      }
    }
  };


  export const providerTypeToChainType = (providerType: string) => {
    if (providerType) {
      switch (providerType.toLowerCase().trim()) {
        case 'mainnet-ethr-did':
        case 'rinkeby-ethr-did':
        case 'ropsten-ethr-did':
        case 'central-ethr-did':
          return 'ethereum';
        case 'david19-ethr-did':
        case 'academy-ethr-did':
          return 'lacchain';
        case 'mainnet-polygon-did':
        case 'testnet-polygon-did':
          return 'polygon';
        default:
          return null;
      }
    }
  };
